import { render, staticRenderFns } from "./sxTabConfirm.vue?vue&type=template&id=763c1980&scoped=true"
import script from "./sxTabConfirm.vue?vue&type=script&lang=js"
export * from "./sxTabConfirm.vue?vue&type=script&lang=js"
import style0 from "./sxTabConfirm.vue?vue&type=style&index=0&id=763c1980&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763c1980",
  null
  
)

export default component.exports